const wrapperCls = "dibw9zu8bx";
const copyInputWrapperCls = "dibc1qa59c9";
const focusSelector = "dibf11al72f";
const copyInputCls = "dibcxcu3g9";
const copyButtonCls = "dibcbxf9tt";
const copyButtonTextCls = "dibckrbwc0";

export { copyButtonCls, copyButtonTextCls, copyInputCls, copyInputWrapperCls, focusSelector, wrapperCls };
import "./copy-link-button.style.linaria.module.css";
//# sourceMappingURL=copy-link-button.style.js.map
